module.exports = __webpack_public_path__ + "static/img/冻雨.706710a5.svg";